"use client";

import React from "react";
import { ShieldCheck, Coins, Globe } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Architectural Precision",
  description: "From initial 3D rendering to the final structural beam, our craftsmen execute every detail with surgical accuracy and uncompromising standards.",
  icon: ShieldCheck
}, {
  title: "Radical Transparency",
  description: "We provide clear, fixed-price modeling and honest timelines. No hidden costs—just a straightforward path to your dream residential space.",
  icon: Coins
}, {
  title: "Bespoke Quality",
  description: "Specializing in high-end whole home remodels and ADUs, we treat every project as a unique piece of functional art for the Denver metro area.",
  icon: Globe
}];
export default function WhyTravelersChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="224920" id="our-core-values" className="dark bg-background text-foreground py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tighter mb-4 text-primary">
            Our Core Values
          </h2>
          <p className="font-default text-muted-foreground text-xl leading-relaxed">At BT Remodeling our motto is: "No homeowner left behind"</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-card border-border/40 shadow-lg transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl group rounded-md">
                  <CardHeader className="px-8 pt-8 pb-4">
                    <div className="mb-6 inline-flex items-center justify-center rounded-md bg-primary/10 p-3 text-primary transition-colors group-hover:bg-primary/20">
                      <Icon className="w-8 h-8" strokeWidth={1} />
                    </div>
                    <CardTitle className="font-default text-2xl font-semibold text-card-foreground tracking-tight">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-8">
                    <CardDescription className="font-default text-base leading-relaxed text-muted-foreground">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}